import React from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { OurStory } from './components/OurStory';
import { Services } from './components/Services';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServiceArea } from './components/ServiceArea';
import { Testimonials } from './components/Testimonials';
import { CTABanner } from './components/CTABanner';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-white" data-id="element-0">
      <Header data-id="element-1" />
      <Hero data-id="element-2" />
      <Services data-id="element-3" />
      <About data-id="element-4" />
      {/* <OurStory /> */}
      <WhyChooseUs data-id="element-5" />
      <ServiceArea data-id="element-6" />
      <Testimonials data-id="element-7" />
      <CTABanner data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}